import React from 'react'
import {connect} from 'react-redux'

import {
  SESSION_STATUSES
} from '../shared/config/constants'


import formatSummaryDateTime from '../shared/data/formatters/summary_date_time'
import isSessionOnTime from '../shared/data/helpers/is_session_on_time'
import showModal from '../shared/data/actions/show_modal'
import GoToSessionButton from './go_to_session_button'

class ExpertConversationSessionProgressAction extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.onRequestSession = this.onRequestSession.bind(this)
  }

  onRequestSession (e) {
    if (e) e.preventDefault()

    this.props.showInitiateSessionModal({
      type: 'sessionInitiate',
      props: {expert: this.props.expert}
    })
  }

  render () {
    if (!this.props.sessionId) {
      return (
        <a href='#' className={this.props.classNames} onClick={this.onRequestSession}>
          Request paid session
        </a>
      )
    }

    if (this.props.sessionId && this.props.session) {
      const status = this.props.session.get('status')
      const startTime = this.props.session.get('startTime')

      if (status >= SESSION_STATUSES.BOOKED && status <= SESSION_STATUSES.PAUSED) {
        if (isSessionOnTime(startTime)) {
          return (
            <GoToSessionButton
              classNames={this.props.classNames}
              sessionId={this.props.sessionId}/>
          )
        }
        else {
          return (
            <h5>Session on {formatSummaryDateTime(startTime)}</h5>
          )
        }
      }
    }

    return false
  }
}

ExpertConversationSessionProgressAction.defaultProps = {
  classNames: 'button success'
}

const mapStateToProps = (state, ownProps) => {
  return {
    session: state.getIn(['sessions', 'experts', ownProps.sessionId])
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showInitiateSessionModal: (modal) => dispatch(showModal(modal))
  }
}

const ExpertConversationSessionProgressActionContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ExpertConversationSessionProgressAction)

export default ExpertConversationSessionProgressActionContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/expert_conversation_session_progress_action.js
 **/